export const SetFareCalculation = 'SetFareCalculation'
export const setFareCalculation = usingFare => ({ type: SetFareCalculation, usingFare })

export const SetShowHSE = 'SetShowHSE'
export const setShowHSE = showHSE => ({ type: SetShowHSE, showHSE })
